module.exports = __webpack_public_path__ + "img/shequn.810e34f0.png";